import GuestCheckoutSuccessDutchiePay from './guest-checkout-success-dutchie-pay';

export default GuestCheckoutSuccessDutchiePay;
